export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_MSAL_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_MSAL_TENANT_ID}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read", "Sites.ReadWrite.All", "Files.ReadWrite.All"],
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

/**
 * SharePoint Configuration
 *
 * IMPORTANT: Update with your SharePoint site URL
 */
export const sharePointConfig = {
  siteUrl: import.meta.env.VITE_SHAREPOINT_SITE_URL,

  // List names - DO NOT CHANGE unless you modify SharePoint lists
  listNames: {
    assets: "Assets",
    entities: "Entities",
    entitySignals: "EntitySignals",
    dependencyRules: "DependencyRules",
    alertsLog: "AlertsLog",
    roleAssignments: "RoleAssignments",
    notificationSettings: "NotificationSettings",
  },
};

/**
 * Entity Types Configuration
 * These are loaded dynamically from SharePoint but defined here for reference
 */
export const entityTypes = {
  METRIC: "Metric",
  PROJECT: "Project",
  CSF: "CSF",
  CONSTRAINT: "Constraint",
  INITIATIVE: "Initiative",
};

/**
 * Rule Types Configuration
 */
export const ruleTypes = {
  REQUIRED: "Required",
  CONTRIBUTES: "Contributes",
  BLOCKS: "Blocks",
};

/**
 * Status Configuration
 */
export const statusValues = {
  MET: "Met",
  AT_RISK: "At Risk",
  NOT_MET: "Not Met",
  ON_TRACK: "On Track",
  DELAYED: "Delayed",
  BLOCKED: "Blocked",
  COMPLETED: "Completed",
};

/**
 * Severity Levels
 */
export const severityLevels = {
  INFO: "Info",
  WARNING: "Warning",
  CRITICAL: "Critical",
};

/**
 * User Roles
 */
export const userRoles = {
  EXECUTIVE: "Executive",
  ASSET_MANAGER: "AssetManager",
  VIEWER: "Viewer",
};
